import { render, staticRenderFns } from "./BoardArticleWebpart.vue?vue&type=template&id=50f45945&scoped=true"
import script from "./BoardArticleWebpart.ts?vue&type=script&lang=ts&external"
export * from "./BoardArticleWebpart.ts?vue&type=script&lang=ts&external"
import style0 from "./BoardArticleWebpart.vue?vue&type=style&index=0&id=50f45945&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f45945",
  null
  
)

export default component.exports